// extracted by mini-css-extract-plugin
module.exports = {"EstimateTitle":"Page_EstimateTitle__CUEez"};